<template>
  <div class="work_order_manage" :style="'min-height:' + height + 'px;'">
    <p class="box_title">工单</p>
    <div class="box_form">
      <div>
        <p style="color: #676767;margin-bottom: 5px;">订单号:</p>
        <el-input v-model="reqForm.orderNum" placeholder="贵司订单号/科坦订单号" size="mini" clearable></el-input>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">工单号:</p>
        <el-input v-model="reqForm.workOrderId" placeholder="请输入工单号" size="mini" clearable></el-input>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">创建时间:</p>
        <el-date-picker v-model="reqForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="yyyy-MM-dd" size="mini" clearable style="width: 240px;">
        </el-date-picker>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">工单类型:</p>
        <el-select v-model="reqForm.subTypeIds" size="mini" clearable multiple collapse-tags>
          <el-option v-for="item in workOrderTypes" :key="item.typeId" :value="item.typeId"
            :label="item.typeName"></el-option>
        </el-select>
      </div>
      <div style="display: flex;align-items: center;">
        <div>
          <p style="color: #676767;margin-bottom: 5px;">工单状态:</p>
          <el-select v-model="reqForm.status" size="mini" style="width: 140px;" clearable multiple collapse-tags>
            <el-option :value="0" label="待处理"></el-option>
            <el-option :value="1" label="处理中"></el-option>
            <el-option :value="2" label="已完成"></el-option>
          </el-select>
        </div>
        <div style="margin-left: 10px;">
          <p style="color: #676767;margin-bottom: 15px;"></p>
          <b2b-button style="width: 80px;height: 28px;line-height: 28px;" @click="search(true)">搜索</b2b-button>
        </div>
      </div>
    </div>

    <div class="tip_box">
      <img src="../../../assets/newImage/tip_tip.png" alt="" style="width: 14px;height: 14px">
      <span>一共</span>
      <span class="num">{{ workOrderCountInfo['total'] ? workOrderCountInfo['total'] : 0 }}</span>
      <span>条工单 待处理</span>
      <span class="num">{{ workOrderCountInfo[0] ? workOrderCountInfo[0] : 0 }}</span>
      <span>条 处理中</span>
      <span class="num">{{ workOrderCountInfo[1] ? workOrderCountInfo[1] : 0 }}</span>
      <span>条</span>
      <span>已完成</span>
      <span class="num">{{ workOrderCountInfo[2] ? workOrderCountInfo[2] : 0 }}</span>
      <span>条</span>
    </div>

    <el-table :data="workOrders" style="width: 100%; margin-top: 20px; font-size: 12px">
      <el-table-column label="工单号" prop="workOrderId" width="120">
      </el-table-column>
      <el-table-column label="贵司订单号" prop="channelOrderNum" width="120">
      </el-table-column>
      <el-table-column label="科坦订单号" prop="outerOrderId" width="120">
      </el-table-column>
      <el-table-column label="工单类型" prop="subTypeId" width="160">
        <template slot-scope="scope">
          {{ getWorkOrderType(scope.row.subTypeId) }}
        </template>
      </el-table-column>
      <el-table-column label="工单内容" prop="content" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="80" sortable>
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;">
            <span class="dot" :style="'background-color:' + getWorkOrderStatusColoe(scope.row.status)"></span>
            <span :style="'color:' + getWorkOrderStatusColoe(scope.row.status)">
              {{ getWorkOrderStatusName(scope.row.status) }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="150" sortable>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <p @click="toDetail(scope.row)" style="color:#1e50f0;cursor: pointer;">详情</p>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination :current-page="reqForm.pageCurrent" :page-size="reqForm.pageSize"
        layout="total, prev, pager, next, jumper" :total="total" :hide-on-single-page="true" @current-change="pageChange"
        style="margin: auto;">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: 0,
      partnerInfo: {},
      reqForm: {
        dateRange: [],
        pageSize: 20,
        pageCurrent: 1
      },
      total: 0,
      workOrders: [],
      workOrderTypes: [],
      workOrderCountInfo: {}
    }
  },
  created () {
    this.height = this.$common.getScreenInfo().height - 90 - 40
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    let nowDateTime = new Date().getTime()
    let dateForm = new Date(nowDateTime - (86400000 * 30)).Format('yyyy-MM-dd')
    let dateTo = new Date(nowDateTime).Format('yyyy-MM-dd')
    this.reqForm.dateRange = [dateForm, dateTo]
    this.getWorkOrderTypes()
    this.search(true)
  },
  methods: {
    async getWorkOrderTypes () {
      const { data: result } = await this.$http.get('/work_order_api/2.0/workOrderTypes')
      if (result.resultCode != 0) return this.$message.error("网络错误，请稍后再试")
      this.workOrderTypes = result.workOrderTypes
    },
    async search (type) {
      let reqHeaders = {
        headers: {
          accessToken: this.partnerInfo.token
        }
      }
      if (type) {
        this.reqForm.pageCurrent = 1
        this.searchWorkOrderInfos()
      }
      const { data: result } = await this.$http.post('/mini/searchWorkOrders', this.reqForm, reqHeaders)
      if (result.code != 200) return this.$message.error(result.message)
      this.workOrders = result.data.items
      this.workOrders.forEach((item) => {
        if (!item.status && item.status != 0) {
          this.$set(item, 'status', 0)
        }
      })
      this.total = result.data.total
    },
    async searchWorkOrderInfos () {
      let reqHeaders = {
        headers: {
          accessToken: this.partnerInfo.token
        }
      }
      const { data: result } = await this.$http.get('/mini/searchWorkOrderCountInfo', reqHeaders)
      if (result.code != 200) return this.$message.error(result.message)
      this.workOrderCountInfo = result.data
      let total = Object.values(this.workOrderCountInfo).map(item => item).reduce((acc, curr) => acc + curr, 0)
      this.workOrderCountInfo.total = total
    },
    pageChange (e) {
      this.reqForm.pageCurrent = e
      this.search()
    },
    getWorkOrderType (typeId) {
      let typeInfo = this.workOrderTypes.filter(item => item.typeId == typeId)[0]
      return typeInfo ? typeInfo.typeName : '未知'
    },
    getWorkOrderStatusName (status) {
      if (!status) {
        return "待处理"
      }
      return status == 1 ? "处理中" : "已完成"
    },
    getWorkOrderStatusColoe (status) {
      if (!status) {
        return "#909399"
      }
      return status == 1 ? "#f6c659" : "#67c23a"
    },
    async toDetail (row) {
      let reqHeaders = {
        headers: {
          accessToken: this.partnerInfo.token
        }
      }
      let loading = this.$loading({
        text: '努力加载中，请稍后.....',
        spinner: 'el-icon-loading',
        background: this.$finalData.LoadingBgColorAll
      })
      const { data: result } = await this.$http.get(`/mini/searchOrderByOuterId?outerOrderId=${row.outerOrderId}`, reqHeaders)
      loading.close()
      if (result.code != 200) return this.$message.error('网络错误，请稍后再试')
      if (result.data && result.data.length) {
        let order = result.data[0]
        order.newWorkOrderId = row.workOrderId
        let url = '/orderDetail?params=' + window.btoa(encodeURIComponent(JSON.stringify(order)))
        window.open(url, '_blank');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.work_order_manage {
  background-color: #fff;
  padding: 20px;

  .box_title {
    font-size: 16px;
    font-weight: bold;
    font-family: '苹方';
    margin-bottom: 15px;
  }


  .box_form {
    border: 1px solid #e7e7e7;
    background-color: #f7f7f7;
    margin-bottom: 15px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 15px;
    align-items: center;
  }

  .tip_box {
    background: #e6f7ff;
    border: 1px solid #9edaff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    column-gap: 5px;
    padding: 10px;

    .num {
      color: #59acef;
    }
  }

  .dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #1ef150;
    border-radius: 50%;
    margin-right: 5px;
  }

  /deep/.el-table th,
  .el-table tr {
    background-color: #f7f7f7;
  }

  .pagination {
    margin: 35px;
    position: relative;

    /deep/ .el-pagination {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/order/WorkOrderManage.vue